<template>
  <div class="conter suggest suggest3">
    <div v-if="noData =='false'">
      <!-- 签名弹出层 -->
      <div v-show="test" class="sign" style="position:fixed;top:0;z-index:9999">
        <signature @closePop="closePop" @saveImg="complete"></signature>
      </div>
      <!-- 签名弹出层结束 -->
      <!-- 详情数据 -->
      <detailsCom :id="voteId" :type="type"></detailsCom>
      <!-- 详情数据结束 -->
      <!-- 我的意见 -->
      <div v-if="forTheFirstTime == 0">
        <div class="suggest-content">
          <div class="suggest-p">我的意见</div>
          <!-- 审批盒子  -->
          <van-field
            v-model="conter"
            rows="4"
            autosize
            type="textarea"
            maxlength="500"
            placeholder="请输入意见，字数在500字以内。"
            show-word-limit
            class="textAear-box"
          />
          <span class="textAear-tips">说明：超过500字的意见，请发文件到医院OA!</span>
          <!-- <input v-model="conter" /> -->
          <!--审批盒子结束  -->
        </div>
        <!-- 签名 -->
        <div v-if="imgData && isSignature==1" class="resign">
          <div class="sign_title">我的签名</div>
          <div style="width:50px;margin-left:30%">
            <img class="sign-img" :src="imgData" />
          </div>
          <span @click="showPopup" class="resign-txt">重新签名</span>
        </div>
        <div v-else-if="!imgData && isSignature==1" @click="showPopup" class="sign-box">
          <p class="sign-p1">本人签名</p>
          <el-button class="sign-btn">
            <span class="img"></span>签名
          </el-button>
        </div>
        <!-- 签名结束 -->
        <div class="sign-btn-box">
          <van-button @click="submit" color="#29BEBC" type="primary" block>提交</van-button>
        </div>
      </div>
      <!-- 展示详情 -->
      <div v-else>
        <div class="suggest-box">
          <p class="suggest-p2">我的意见</p>
          <p class="suggest-p3">{{suggest}}</p>
        </div>
        <div class="suggest-box suggest-own">
          <p class="suggest-p2">本人签名</p>
          <div class="img-right">
            <img v-if="resultImgUrl" class="sign-img-icon" :src="resultImgUrl" />
          </div>
        </div>
      </div>
      <!-- 展示详情结束 -->
      <!-- 我的意见结束 -->
    </div>
    <page-none v-if="noData =='true'" />
  </div>
</template>

<script>
import detailsCom from "./details";
import signature from "../../../components/signature.vue";
import { toast } from "@/common/api/api.js";
import pageNone from "../../../components/pageNone";
export default {
  components: {
    detailsCom,
    signature,
    pageNone
  },
  data() {
    return {
      suggest: "",
      forTheFirstTime: "",
      imgData: "", //签名
      test: false,
      resultImgUrl: "",
      isSignature: "",
      conter: "", //意见盒子
      id: "",
      type: "",
      voteId: this.$route.query.voteId,
      noData: ""
    };
  },
  created() {
    this.getDetails();
    console.log('参数id',this.$route.query.voteId)
  },
  methods: {
    //处理返回数据
    getDetailsFun(data, message) {
      console.log('处理返回数据',data)
      this.isSignature = data.vote.isSignature;
      this.forTheFirstTime = data.suggest.statusp;
      this.type = data.vote.type;
      this.id = data.suggest.id;
      if (this.forTheFirstTime != 0) {
        this.resultImgUrl = data.suggest.signatrue;
        this.suggest = data.suggest.suggest;
      }
    },
    //获取详情参数
    getgetDetailsData() {
      var obj = {
        id: this.voteId
      };
      return obj;
    },
    //获取详情数据
    getDetails() {
      console.log('意见详情获取')
      var obj = this.getgetDetailsData();
      console.log('参数',obj)
      this.sendQuestion("wechatRepreDetail", obj, "getDetailsFun");
    },
    //获取提价参数
    getSubmitData() {
      var obj = {
        voteId: this.voteId,
        id: this.id,
        suggest: this.conter,
        signatrue: this.imgData
      };
      return obj;
    },
    //提交成功
    submitFun(data, message) {
      toast(this, message, "success");
      this.$router.go(-1);
    },
    //提交函数
    submit() {
      if (this.conter == "") {
        toast(this, "我的意见不能为空!", "error");
        return;
      }
      if (this.isSignature == 1 && (!this.imgData || this.imgData == "")) {
        toast(this, "签名不能为空!", "error");
        return;
      }
      var obj = this.getSubmitData();
      this.sendQuestion("subDemoraticVoteSuggest", obj, "submitFun");
    },
    complete(data) {
      this.imgData = data;
      this.test = false;
    },
    closePop() {
      this.test = false;
    },
    showPopup() {
      this.test = !this.test;
    },
    //后端发送请求函数
    sendQuestion(url, obj, fun) {
      this.centralControl.axios.centralControl(
        url,
        res => {
          const { message, code, data } = res;
          //请求返回 关闭加载页
          this.loading = false;
          if (code == 200) {
            this.noData = "false";
            this[fun](data, message);
          } else {
            this.noData = "true";
            toast(this, message, "error");
            console.log(res, "接口错误-");
          }
        },
        obj
      );
    }
  }
};
</script>

<style lang="stylus" type="stylesheet/stylus">
@import '../../../assets/stylus/theme.styl';
@import '../../../assets/stylus/common.styl';

.suggest3 {
  .resign {
    margin: 15px;
  }

  .resign-txt {
    font-style: normal;
  }

  .resign {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 5px 15px;
    margin: 0;

    .sign-img {
      width: 50%;
      transform: rotate(90deg);
    }
  }
}

.conter {
  width: 100%;
  height: 100%;
}

.suggest-box {
  background: #fff;
  padding: 20px 15px 10px;
  margin-bottom: 10px;

  .suggest-p2 {
    stepTextStyle();
    color: $text-black;
  }

  .suggest-p3 {
    stepTextStyle();
    color: $text-gray;
    line-height: 20px;
    letter-spacing: 1px;
    margin-top: 10px;
  }
}

.sign {
  .el-form-item__label {
    left: 50%;
    transform: translateY(-50%);
  }

  .resign {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .sign-img {
      width: 200px;
      height: 150px;
      transform: rotate(90deg);
    }
  }
}

.suggest-own {
  padding: 15px;
  display: flex;
  align-items: center;

  .img-right {
    flex: 1;
    text-align: center;
  }

  .sign-img-icon {
    width: 120px;
    height: 47px;
  }
}

.sign-btn-box {
  width: 87%;
  margin: 20px auto;
}

.sign-box {
  background: #fff;
  display: flex;
  align-items: center;
  padding: 18px 15px;

  .sign-p1 {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: $text-black;
    width: 80px;
    text-align: left;
  }
}

.suggest-content {
  background: #fff;
  margin: 10px auto;
  padding: 15px;

  .textAear-box {
    background: rgba(244, 245, 249, 1);
    border-radius: 10px;
    font-size: 14px;
    margin: 20px 0 10px 0;
    // margin:20px auto 10px auto;
  }
  .textAear-tips {
    font-size: 14px;
    color: #ccc;
    font-family: PingFang SC;
  }

  >>> .van-field__control {
    font-size: 14px;
    color: #B2B2B2;
  }

  .suggest-p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: $text-black;
  }
}

.sign-btn {
  flex: 1;
  color: #38c7c4;
  border-color: $default-color;
  background-color: #fff;
  border-radius: 0;

  .img {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url('/img/icon-sign.00caefc8.png') no-repeat center center;
    background-size: 100% 100%;
    vertical-align: middle;
    margin-right: 5px;
  }
}

.resign-txt {
  color: $default-color;
  font-size: 12px;
  font-style: italic;
  display: inline-block;
  text-align: center;
}
</style>